export const FOUNDER = {
  id: 'founder',
  name: 'Founder'
}
export const CEO = {
  id: 'ceo',
  name: 'CEO'
}
export const HEADOFDIVISION = {
  id: 'headofdivision',
  name: 'Head of Division'
}
export const EMPLOYEE = {
  id: 'employee',
  name: 'Employee'
}
export const EXECUTIVE = {
  id: 'executive',
  name: 'Executive'
}
export const HEADOFDEPARTMENT = {
  id: 'headofdepartment',
  name: 'Head of Department'
}
export const HEADOFSECTION = {
  id: 'headofsection',
  name: 'Head of Section'
}
export const ROLES_LIST = [FOUNDER, CEO, EXECUTIVE, HEADOFDIVISION, HEADOFDEPARTMENT, HEADOFSECTION, EMPLOYEE]



// WEBPACK FOOTER //
// ./src/constants/roles.js